import _ from 'lodash';
import { notApplicable } from 'helpers';
import { normalizeDraftPriorities } from './priorities';

// Hooks
import { useSelector } from 'react-redux';

const useAdmission = (favorites = [], studentStatus = {}, { draft = false } = {}) => {
  const profile = useSelector((state) => _.get(state, 'app.user') || {});
  const courseMap = useSelector((state) => _.get(state, 'app.courseMap')) || {};
  const removes = useSelector((state) => _.get(state, 'app.admissionRemoves')) || [];

  const selected = favorites.filter(({ _id, priority }) => priority != null && !removes.includes(_id)).sort((a, b) => a.priority - b.priority);
  const projects = draft ? normalizeDraftPriorities(selected) : selected;
  const nextPriority = (_.max(projects.map(({ priority }) => priority)) || 0) + 1
  const availables = favorites.filter(({ _id, priority, program_project }) => (priority == null || removes.includes(_id)) && courseMap[program_project] && !notApplicable(profile, courseMap[program_project], { studentStatus, favorites: projects, nextPriority }).length);

  return {
    projects,
    availables,
    nextPriority,
    removes
  }
}

export default useAdmission;
